import React from 'react';
import { connect } from 'react-redux';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';

// function UserContainerScreen(props) {
function UserContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/user/list/:userType/:name"
        pathPermissionId={UserPermissionsIds.ManageUsers}
        render={(props) => ViewMounter(props, {
          viewPath: 'user/grid/users',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
        exact={false}
      />
      <SecureRoute
        path="/user/list"
        pathPermissionId={UserPermissionsIds.ManageUsers}
        render={(props) => ViewMounter(props, {
          viewPath: 'user/grid/users',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
        exact
      />
      <SecureRoute
        path="/user/profile/:id"
        pathPermissionId={UserPermissionsIds.ReadUsers}
        render={(props) => {
          return (
            ViewMounter(props, {
              viewPath: 'user/grid/edit_user_profile',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              focusView: true,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              params: undefined
            })
          );
        }}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/user/add"
        pathPermissionId={UserPermissionsIds.CreateUsers}
        render={(props) => {
          return (
            ViewMounter(props, {
              viewPath: 'user/add_user/add_user',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              focusView: true,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              params: undefined
            })
          );
        }}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    empty: state.empty,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(UserContainerScreen);
